export enum AuthStatus {
  NoAuth,
  Pending,
  Auth
}
